import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const EnergyIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M24.1 49.2c-1.9 0-3.4-1.5-3.4-3.4v-.6c-1.2-.4-2-1.5-2-2.8v-8.6c-5.3-2.6-8.2-8.3-7.4-14.2.9-6 5.8-10.7 11.8-11.4.6-.1 1.2-.2 1.7-.2 7.5 0 13.6 6.1 13.6 13.6 0 5-2.6 9.4-6.9 11.8v9.3c0 1.1-.7 2.1-1.7 2.5v.6c0 1.9-1.5 3.4-3.4 3.4h-2.3z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M24.8 9c7 0 12.6 5.6 12.6 12.6 0 4.9-2.8 9.2-6.9 11.2v9.9c0 .9-.8 1.7-1.7 1.7v1.4c0 1.3-1.1 2.4-2.4 2.4h-2.3c-1.3 0-2.4-1.1-2.4-2.4v-1.4c-1.1 0-2-.9-2-2v-9.2c-5-2.2-8.2-7.5-7.4-13.4.8-5.5 5.4-9.9 10.9-10.6.6-.1 1.1-.2 1.6-.2m0-2c-.6 0-1.2 0-1.7.1-6.5.8-11.7 5.8-12.7 12.3-.9 6.1 2.1 12 7.3 15v8c0 1.5.8 2.8 2 3.5 0 2.4 2 4.3 4.4 4.3h2.3c2.4 0 4.4-2 4.4-4.4 1-.7 1.7-1.8 1.7-3.1V34c4.3-2.6 6.9-7.3 6.9-12.4 0-8-6.5-14.6-14.6-14.6z"
        fill="#00000"
        className={styles.defaultColor}
      />
      <path d="M25.1.4v4.7" fill="#e8ebed" strokeLinecap="round" />
      <path
        d="M15.4 21.6c0-5.4 4.4-9.7 9.7-9.7"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
      />
      <path
        d="m13.8 3.9 2.5 3.9M6.5 11.1l3.9 2.2M3.8 21.6h4.3M33.8 7.7l2-3.6M39.2 13l3.8-2.2M41.6 21.6h4.6"
        fill="#e8ebed"
        strokeLinecap="round"
      />
      <path
        d="M19.1 37.7h12M19.1 40.7h12"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
      />
      <path
        d="M25.3 34.8s-9.9-7 .2-17.5c0 0 8.9 9.6-.2 17.5z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M25.3 26.9v9"
        fill="none"
        stroke="#ffffff"
        className={styles.white}
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </Icon>
  )
}
